import { z } from "nestjs-zod/z";
import { createZodDto } from "nestjs-zod/dto";

export const dashboardAnalyticsSchema = z.object({
  profileCompletionPercentage: z.number().min(0).max(100),
  totalResumes: z.number().min(0),
  totalViews: z.number().min(0),
  totalDownloads: z.number().min(0),
  achievements: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      description: z.string(),
      icon: z.string(),
      earned: z.boolean(),
      earnedAt: z.date().or(z.dateString()).optional(),
      actionText: z.string(),
    }),
  ),
  recentActivity: z.array(
    z.object({
      id: z.string(),
      type: z.enum(["resume_created", "resume_updated", "resume_viewed", "resume_downloaded"]),
      resumeTitle: z.string().optional(),
      timestamp: z.date().or(z.dateString()),
    }),
  ),
});

export class DashboardAnalyticsDto extends createZodDto(dashboardAnalyticsSchema) {}
